export default __webpack_public_path__ + "static/media/pop_up_6_JB.e741f40b.jpg";